window.__WWAI__ = window.__WWAI__ || {};

// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = true;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "umc_freshcap_pdp_Q7LYhj": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "ultimate-mushroom-complex-capsules-sticky": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "ultimate-mushroom-complex-capsules",
        "defaultVariantOption1": "120 Capsules",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "ultimate-mushroom-complex-capsules",
        "allOptions": {
          "option1": "60 Capsules | 120 Capsules | 180 Capsules",
          "option2": "",
          "option3": ""
        }
      }
    },
    "ultimate-mushroom-complex-capsules": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "ultimate-mushroom-complex-capsules",
        "defaultVariantOption1": "120 Capsules",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "ultimate-mushroom-complex-capsules",
        "allOptions": {
          "option1": "60 Capsules | 120 Capsules | 180 Capsules",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "umc_freshcap_products_BMUUyY": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": false
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "lions-mane-capsules": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "lions-mane-capsules",
        "defaultVariantOption1": "60 Capsules",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "lions-mane-capsules",
        "allOptions": {
          "option1": "60 Capsules | 120 Capsules",
          "option2": "",
          "option3": ""
        }
      }
    },
    "ultimate-mushroom-complex-powder": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "ultimate-mushroom-complex-powder",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "ultimate-mushroom-complex-powder",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "cordyceps-capsules": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "cordyceps-capsules",
        "defaultVariantOption1": "60 Capsules",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "cordyceps-capsules",
        "allOptions": {
          "option1": "60 Capsules | 120 Capsules",
          "option2": "",
          "option3": ""
        }
      }
    },
    "reishi-capsules": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "reishi-capsules",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "reishi-capsules",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "umc_freshcap_pdp_Q7LYhj": {
    "ultimate-mushroom-complex-capsules-sticky": {
      "ultimate-mushroom-complex-capsules": {
        "60 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "120 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "180 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "ultimate-mushroom-complex-capsules": {
      "ultimate-mushroom-complex-capsules": {
        "60 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 5,
          "customLabelText": {}
        },
        "120 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 0,
          "customLabelText": {}
        },
        "180 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": 6,
          "customLabelText": {}
        }
      }
    }
  },
  "umc_freshcap_products_BMUUyY": {
    "lions-mane-capsules": {
      "lions-mane-capsules": {
        "60 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "120 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "ultimate-mushroom-complex-powder": {
      "ultimate-mushroom-complex-powder": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "cordyceps-capsules": {
      "cordyceps-capsules": {
        "60 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "120 Capsules": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "reishi-capsules": {
      "reishi-capsules": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.WWAI_ACTION_BUTTONS = undefined;
